import React from 'react'
import { Alcance } from '../Alcance';
import { yearMeasure } from '../pages/Home';
import { guardarMeasure } from '../firebase';
import * as BsIcons from 'react-icons/bs';
import * as FaIcons from 'react-icons/fa';
import * as HiIcons from 'react-icons/hi';
import './Medir.css';
import { distancia_input, origen_input, destino_input } from '../pages/valores';

function MedirTransporteAereo( props ) {

    const sub = props.sub

    //const [startDate, setStartDate] = React.useState(new Date());
    const [nombreEntrada, setNombreEntrada] = React.useState('Transporte materia prima');
    const [origen, setOrigen] = React.useState('');
    const [destino, setDestino] = React.useState('');
    //const [trayecto, setTrayecto] = React.useState('');
    const [kilometros, setKilometros] = React.useState('');
    const [tipoVehiculo, setTipoVehiculo] = React.useState('');
    const [marcaReferencia, setMarcaReferencia] = React.useState('');
    const [unidadesTransportadas, setUnidadesTransportadas] = React.useState(1);
    const [peso, setPeso] = React.useState();
    const [alcance, setAlcance] = React.useState(1);
    const [numeroViajeros, setNumeroViajeros] = React.useState(0);
    //const [numeroRecorridos, setNumeroRecorridos] = React.useState(1);

    const [tipoTransporteAereo, setTipoTransporteAereo] = React.useState('Carga');
    const [tipoViaje, setTipoViaje] = React.useState('Directo');
    const [claseVuelo, setClaseVuelo] = React.useState('Economico');
    const [vueloNalInternal, setVueloNalInternal] = React.useState('Nacional');
    const [classValida, setClassValida] = React.useState('class__valida__red');
    const [isCargado, setIsCargado] = React.useState(false);    

    const handleNombreEntrada = (event) => {
        setNombreEntrada(event.target.value);
      }
      const onClickSelectNombre =(event)=>{
        setClassValida('class__valida__green')
        setNombreEntrada(event.target.value);
      }
      const handleOrigen = (event) => {
        setOrigen(event.target.value);
        //setTrayecto(event.target.value +' - '+ destino +' - '+ event.target.value)
      }
      const handleDestino = (event) => {
        setDestino(event.target.value);
        //setTrayecto(origen +' - '+ event.target.value +' - '+ origen)
      }
      /*const handleTrayecto = (event) => {
          setTrayecto(event.target.value)
      }*/

      /*const handleTipoVehiculo = (event) => {
        setTipoVehiculo(event.target.value);
      }*/
      const handleMarcaReferencia = (event) => {
        setMarcaReferencia(event.target.value);
      }      
      /*const handleKilometros = (event) => {
        console.log('kilometros: '+kilometros);
        setKilometros(event.target.value);
      }
      const handleUnidadesTransportadas = (event) => {
        console.log('UnidadesTransportadas: '+unidadesTransportadas);
        setUnidadesTransportadas(event.target.value);
      }
      const handlePeso = (event) => {
        console.log('cPeso: '+peso);
        setPeso(event.target.value);
      }
      const handleNumeroViajeros = (event) => {
        setNumeroViajeros(event.target.value);
        if (event.target.value)
        console.log('Numero Viajeros: '+event.target.value);
      }
      const handleNumeroRecorridos = (event) => {
        setNumeroRecorridos(event.target.value);
        console.log('Numero Recorridos: '+event.target.value);
      }*/
      const handleAlcance = (event) => {
        setAlcance(event.target.value);
      }
      
      async function handleTipoTransporte (event) {
        setTipoTransporteAereo(event.target.value);
        
        if (tipoTransporteAereo === "Carga") {
            //document.getElementById('claseVuelo').style.display = 'block';
            document.getElementById('aereoCarga').style.display = 'none';
            document.getElementById('numeroViajeros').style.display = 'block';
          
        }else{
            //document.getElementById('claseVuelo').style.display = 'none';
            document.getElementById('aereoCarga').style.display = 'block';
            document.getElementById('numeroViajeros').style.display = 'none';
        }
      }

      /*const handleTipoViaje = (event) => {
        setTipoViaje(event.target.value)
      }
      const handleClaseVuelo = (event) => {
        setClaseVuelo(event.target.value)
      }
      const handleNalInternal = (event) => {
          setVueloNalInternal(event.target.value);
      }*/

      const onSubmit = async (event) => {
        event.preventDefault();
            const fecha_modificacion = new Date().toUTCString();

            if (tipoTransporteAereo === 'Pasajeros') {
                let _fe = sub.fe_pasajeros_nacional;
                if ( (Number(kilometros) > 463) && (Number(kilometros) < 1109)) { _fe = sub.fe_pasajeros_corto}
                if ( (Number(kilometros) > 1108) && (Number(kilometros) < 6483)) { _fe = sub.fe_pasajeros_largo}

                let fe_utilizado = Number(_fe) / 1000;

                let resultado_gco2 = Number(kilometros) * _fe * Number(numeroViajeros);

                /*if (vueloNalInternal === 'Internacional') {
                    resultado_gco2 = Number(kilometros) * Number(sub.fe_internacional) * Number(numeroViajeros);
                    fe_utilizado = Number(sub.fe_internacional) / 1000;
                }*/
                let resultado_kgco2 = resultado_gco2 / 1000;
                let measure = {
                    alcance: Number(alcance),
                    categoria: sub.nombre,
                    destino: destino,
                    distancia_km: kilometros,
                    empresa: 'Fibtex',
                    //fecha: startDate,
                    nombre: nombreEntrada,
                    origen: origen,
                    resultado_gco2: resultado_gco2,
                    resultado_kgco2: resultado_kgco2,
                    fe: fe_utilizado,
                    subcategoria: sub.nombre,
                    clase_vuelo: claseVuelo,
                    tipo_viaje: tipoViaje,
                    referencia_producto:'personal',
                    tipo_transporteAereo: tipoTransporteAereo,
                    //numero_recorridos: numeroRecorridos,
                    numero_viajeros: Number(numeroViajeros),
                    user_email: props.user.email,
                    fecha_modificacion: fecha_modificacion,
                    year: yearMeasure
                }
                enviarGuardado(measure)
            }else{
                let _fe = sub.fe_carga_nacional;
                if ( (Number(kilometros) > 463) && (Number(kilometros) < 1109)) { _fe = sub.fe_carga_corto}
                if ( (Number(kilometros) > 1108) && (Number(kilometros) < 6483)) { _fe = sub.fe_carga_largo}

                let resultado_kgco2 = Number(kilometros) * Number(peso) * Number(_fe);
                let measure = {
                    alcance: Number(alcance),
                    categoria: sub.nombre,
                    destino: destino,
                    distancia_km: kilometros,
                    empresa: 'Fibtex',
                    //fecha: startDate,
                    nombre: nombreEntrada,
                    origen: origen,
                    peso_ton: Number(peso),
                    referencia_producto: marcaReferencia,
                    fe: Number(_fe),
                    resultado_kgco2: resultado_kgco2,
                    subcategoria: sub.nombre,
                    unidades_transportadas: unidadesTransportadas,
                    tipo_viaje: tipoViaje,
                    tipo_transporteAereo: tipoTransporteAereo,
                    //numero_recorridos: numeroRecorridos,
                    //trayecto: trayecto,
                    tipo_vehiculo: tipoVehiculo,
                    user_email: props.user.email,
                    fecha_modificacion: fecha_modificacion,
                    year: yearMeasure
                }
                enviarGuardado(measure)
            }
            
      }
      const cerrarInfo=()=>{
        setIsCargado(false);
      }
      const enviarGuardado = async (measure) =>{
          const result = await guardarMeasure(measure);
          console.log(' resultado del guardado :'+result);
          if (result) {
                console.log(result);
                console.log('limpiar inputs ');
                setOrigen('');
                setDestino('');
                //setTrayecto('');
                setKilometros(0);
                setMarcaReferencia('');
                setPeso(0);
                setNumeroViajeros(0);
                //setNumeroRecorridos(0);
                setUnidadesTransportadas(0);
                setIsCargado(true);
          }else{
              alert('Ocurrió un error inesperado, por favor refresque la página e intente de nuevo.')
          }
  
      }

  return (
    
        <div >
        { isCargado &&
              <div className='entrada__ingresada'>
                <div className='items__ingresada'>
                  <h4 style={{background:'transparent'}}  >Registro ingresado correctamente</h4>
                  <button className='items__ingresado__button' onClick={cerrarInfo}>Aceptar</button>
                </div>
              </div>
            }
            <h2 style={{ whiteSpace:'pre-line', textAlign:'center'}}>Subcategoría transporte aéreo</h2>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                <label>Nombre subcategoría</label>
                    <select id='selectNombre' className={classValida} style={{ borderRadius:'1.25rem',width:'100%',display:'block',padding:'0.375rem 0.75rem'}}  
                        value={nombreEntrada} 
                        onChange={handleNombreEntrada}
                        onClick={onClickSelectNombre}>
                        <option value='Transporte materia prima' >Transporte materia prima / producto final</option>
                        <option value='Transporte trabajo' >Transporte trabajo</option>
                    </select>
                </div>
                
                <div className='form-group'>
                    <label>Alcance</label>
                    <Alcance value={alcance} onChange={handleAlcance}></Alcance>
                </div>
                <div className="form-group" onChange={handleTipoTransporte}>
                    <label style={{marginTop:'10px'}}>Tipo de transporte </label>
                    <br/>
                    <label > 
                    <input className='input__medir' defaultChecked type='radio' value='Carga'  name='tipoTransporte' ></input>
                    <label style={{marginLeft:'15px'}}>
                        <HiIcons.HiOutlineBookmarkAlt style={{color:'#1010C5'}}/>
                        <label>Carga</label>
                    </label>
                    </label>
                    <label >
                        <input className='input__medir' type='radio' value='Pasajeros' name='tipoTransporte' ></input>
                        <label style={{marginLeft:'15px'}}>
                        <BsIcons.BsPerson style={{color:'#1010C5'}}/>
                        Pasajeros
                        </label>
                    </label>
                </div>
                <div className="form-group" >
                    <label>Año seleccionado</label>
                    <label className='year__seleccionado' value={yearMeasure} >{yearMeasure}</label>
                    {/*<DatePicker className='datePicker__input' 
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                    />*/}
                </div>
                {/*<div className="form-group">
                <label style={{marginTop:'10px'}}>Tipo de viaje </label>
                    <br/>
                    <label >
                    <input className='input__medir' defaultChecked type='radio' value='Directo'  onChange={handleTipoViaje} name='tipoViaje' ></input>
                    <label style={{marginLeft:'15px'}}>
                        <FaIcons.FaPlaneArrival style={{color:'#1010C5'}}/>
                        Directo  
                        
                    </label>
                    </label>
                    <label >
                    <input className='input__medir' type='radio' value='Escalas' onChange={handleTipoViaje} name='tipoViaje' ></input>
                    <label style={{marginLeft:'15px'}}>
                        <FaIcons.FaPlaneArrival style={{color:'#1010C5'}}/>
                        Con escalas
                        
                    </label>
                    </label>
                </div>*/}

                <div className="form-group">
                    <label>Origen</label>
                    <input required type="text" 
                        className="form-control" 
                        value={origen} 
                        onChange={handleOrigen}
                        onInvalid={(e) => e.target.setCustomValidity(origen_input)}
                        onInput={(e) => e.target.setCustomValidity('')} 
                        placeholder="Origen" 
                    />
                </div>
                <div className="form-group">
                    <label>Destino</label>
                    <input required type="text" 
                        className="form-control" 
                        value={destino} 
                        onChange={handleDestino}
                        onInvalid={(e) => e.target.setCustomValidity(destino_input)}
                        onInput={(e) => e.target.setCustomValidity('')}
                        placeholder="Destino" 
                    />
                </div>
                {/*<div className="form-group">
                    <label>Trayecto completo</label>
                    <input  type="text" className="form-control" value={trayecto} onChange={handleTrayecto} placeholder="Trayecto" />
                </div>*/}
                {/*<div className="form-group">
                    <label>Número recorridos</label>
                    <input  type="number" className="form-control" 
                        value={numeroRecorridos} onChange={e => setNumeroRecorridos(e.target.value)} placeholder="NumeroRecorridos" style={{ width:'25%'}}/>
                </div>*/}
                <div className="form-group">
                    <label>Distancia (km)</label>
                    <input required type="number" step='0.01' 
                        className="form-control"
                        value={kilometros} 
                        onChange={e => setKilometros(e.target.value)} 
                        placeholder="Distancia en km"
                        onInvalid={(e) => e.target.setCustomValidity(distancia_input)}
                        onInput={(e) => e.target.setCustomValidity('')} 
                        style={{ width:'27%'}}
                    />
                </div>
                
                <div id='numeroViajeros' style={{ display:'none'}}>
                    <div className="form-group">
                        <label>Número de viajeros</label>
                        <input type="number" step='0.01' className="form-control"
                            value={numeroViajeros} onChange={e => setNumeroViajeros(e.target.value)} placeholder="Cantidad de viajeros" style={{ width:'25%'}}/>
                    </div>
                </div>

                <div id="aereoCarga" style={{ display:'block'}}>
                    <div className="form-group">
                        <label>Producto o referencia transportada</label>
                        <input type="text" className="form-control" value={marcaReferencia} onChange={handleMarcaReferencia} placeholder="Marca o referencia producto, si es pasajeros escriba personal" />
                    </div>
                    {/*<div className="form-group">
                        <label>Tipo de avión</label>
                        <input type="text" className="form-control" value={tipoVehiculo} onChange={handleTipoVehiculo} placeholder="Tipo avión" />
                    </div>*/}
                    <div className="form-group" id='peso_div'>
                        <label>Peso (Toneladas)</label>
                        <input type="number" step='0.01'
                            className="form-control" value={peso} onChange={e => setPeso(e.target.value)} placeholder="Toneladas" style={{ width:'25%'}}/>
                        </div>
                    <div className="form-group">
                        <label>Unidades transportadas</label>
                        <input type="number" step="0.01" 
                                className="form-control" value={unidadesTransportadas} onChange={e => setUnidadesTransportadas(e.target.value)} placeholder="Cantidad" style={{ width:'25%'}}/>
                    </div>
                </div>
                
                {/*<div className="form-group" id='claseVuelo' style={{ display:'none'}}> 
                    <label style={{marginTop:'10px'}}>Vuelo nacional o internacional</label>
                    <br/>
                    <label >
                        <input className='input__medir' defaultChecked type='radio' value='Nacional'  onChange={handleNalInternal} name='vueloNalInternal' ></input>
                        <label style={{marginLeft:'15px'}}>
                            <FaIcons.FaPlaneArrival style={{color:'#1010C5',marginLeft:'5px'}}/>
                            Nacional
                        </label>
                        
                    </label>
                    <label >
                        <input className='input__medir' type='radio' value='Internacional' onChange={handleNalInternal} name='vueloNalInternal' ></input>
                        <label style={{marginLeft:'15px'}}>
                            <FaIcons.FaPlaneDeparture style={{color:'#1010C5',marginLeft:'5px'}}/>
                            Internacional
                            
                        </label>
                    </label>
                </div>*/}

                <button className='boton__agregar__entrada'>Agregar nueva entrada</button>
            </form>
        </div>
  )
}

export { MedirTransporteAereo }